var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3V29H14.5C15.3284 29 16 29.6716 16 30.5C16 31.3284 15.3284 32 14.5 32H2C0.895432 32 0 31.1046 0 30V2C0 0.895428 0.895433 0 2 0H15.2877C15.8303 0 16.3497 0.220463 16.7265 0.610811L23.4388 7.5628C23.7988 7.93565 24 8.4337 24 8.95199V12.5C24 13.3284 23.3284 14 22.5 14C21.6716 14 21 13.3284 21 12.5V12H15.5C13.567 12 12 10.433 12 8.5V3H3ZM15 3.14168L20.6563 9H15.5C15.2239 9 15 8.77614 15 8.5V3.14168ZM22 30C21.1716 30 20.5 29.3284 20.5 28.5V25.5H17.5C16.6716 25.5 16 24.8284 16 24C16 23.1716 16.6716 22.5 17.5 22.5H20.5V19.5C20.5 18.6716 21.1716 18 22 18C22.8284 18 23.5 18.6716 23.5 19.5V22.5H26.5C27.3284 22.5 28 23.1716 28 24C28 24.8284 27.3284 25.5 26.5 25.5H23.5V28.5C23.5 29.3284 22.8284 30 22 30Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconFile);
export default __webpack_public_path__ + "static/media/upload-icon-file.1605686b71de29edabca514ca6f788d9.svg";
export { ForwardRef as ReactComponent };